export default __webpack_public_path__ + "media/fonts/FiraMono/FiraMono-Medium-c120eb2a406c18aa3fe04722c3939581.otf";